<template>
  <v-container class="main-page-body favorites-view" style="max-width:1442px;padding-top:60px;" :style="{backgroundColor: styles.general.background_color}">
    <div>
        <v-layout row wrap style="margin-bottom: 30px;">
          <v-flex xs12 class="mt-4">
            <h2 style="color:#4a4a4a;font-size:29px;font-weight:bolder;text-justify:auto;" class="page-header">{{ pages.favorites.header }}</h2>
          </v-flex>

          <v-flex xs12 style="color:#4a4a4a;font-size:18px;font-weight:400;margin:0px;" class="page-subtitle">
            <div style="padding-top:0px;">
              <p style="text-justify:auto;line-height:22px;">
                {{ pages.favorites.sub_text }}
              </p>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-card style="width:100%;">
            <v-tabs slider-color="primary" :grow="breakpoint === 'xs' || breakpoint === 'sm'" >
              <v-tab light color="white"  href="#tab-1" class="white" style="height:60px;overflow:none;">
                <div style="text-transform:capitalize;font-size:16px;" >
                  <v-icon class="hidden-md-and-up" medium style="font-size: 23px;">people</v-icon>
                  <span class="hidden-sm-and-down">Contractors</span> ({{ companies.length }})
                </div>
              </v-tab>
              <v-tab light color="white"  href="#tab-2" class="white" style="height:60px;overflow:none;">
                <div style="text-transform:capitalize;font-size:16px;" >
                  <v-icon class="hidden-md-and-up" medium style="font-size: 23px;">people</v-icon>
                  <span class="hidden-sm-and-down">Contract History</span> ({{ contracthistory.length }})
                </div>
              </v-tab>
              <v-tab light color="white" href="#tab-3" style="height:60px;overflow:none;">
                <div style="text-transform:capitalize;font-size:16px;">
                  <v-icon class="hidden-md-and-up" medium style="font-size: 23px;">date_range</v-icon>
                  <span class="hidden-sm-and-down">Events</span> ({{ events.length }})
                </div>
              </v-tab>
              <v-tab-item id="tab-1">
                <v-card-text>
                  <v-layout column wrap style="height:100%;">
                    <v-flex sm12 md12>
                      <v-data-table
                        :headers="tableHeader"
                        :items="companies"
                        :loading="loading"
                        :search="search"
                        :rows-per-page-items="[15, 25, 50, 100]"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.title }}</td>
                          <td class="text-xs-left">
                            <v-layout>
                              <div>
                                <v-tooltip top>
                                  <v-btn :href="props.item.link" target="_blank" slot="activator" icon class="blue--text">
                                    <v-icon>remove_red_eye</v-icon>
                                  </v-btn>
                                  <span>View favorite</span>
                                </v-tooltip>
                              </div>
                              <div>
                                <v-tooltip top>
                                  <v-btn
                                    @click.prevent="removeFavorite(props.item.firebaseRef)"
                                    slot="activator"
                                    icon class="red--text">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                  <span>Remove favorite</span>
                                </v-tooltip>
                              </div>
                            </v-layout>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-tab-item>
              <v-tab-item id="tab-2">
                <v-card-text>
                  <v-layout column wrap style="height:100%;">
                    <v-flex sm12 md12>
                      <v-data-table
                        :headers="historyHeader"
                        :items="contracthistory"
                        :loading="loading"
                        :search="search"
                        :rows-per-page-items="[15, 25, 50, 100]"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.title }}</td>
                          <td class="text-xs-left">
                            <v-layout>
                              <div>
                                <v-tooltip top>
                                  <v-btn :href="props.item.link" target="_blank" slot="activator" icon class="blue--text">
                                    <v-icon>remove_red_eye</v-icon>
                                  </v-btn>
                                  <span>View favorite</span>
                                </v-tooltip>
                              </div>
                              <div>
                                <v-tooltip top>
                                  <v-btn
                                    @click.prevent="removeFavorite(props.item.firebaseRef)"
                                    slot="activator"
                                    icon class="red--text">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                  <span>Remove favorite</span>
                                </v-tooltip>
                              </div>
                            </v-layout>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-tab-item>
              <v-tab-item id="tab-3">
                <v-card-text>
                  <v-layout row wrap style="height:100%;" >
                    <v-flex sm12 md12>
                      <v-data-table
                        :headers="tableHeader"
                        :items="events"
                        :rows-per-page-items="[15, 25, 50, 100]"
                        :loading="loading"
                        :search="search"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.title }}</td>
                          <td class="text-xs-left">
                            <v-layout>
                              <div>
                                <v-tooltip top>
                                  <v-btn :href="props.item.link" target="_blank" slot="activator" icon class="blue--text">
                                    <v-icon>remove_red_eye</v-icon>
                                  </v-btn>
                                  <span>View favorite</span>
                                </v-tooltip>
                              </div>
                              <div>
                                <v-tooltip top>
                                  <v-btn
                                    @click.prevent="removeFavorite(props.item.firebaseRef)"
                                    slot="activator"
                                    icon class="red--text">
                                    <v-icon>clear</v-icon>
                                  </v-btn>
                                  <span>Remove favorite</span>
                                </v-tooltip>
                              </div>
                            </v-layout>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-layout>
    </div>
  </v-container>
</template>

<script>
  import FeedbackComponent from '../components/FeedbackComponent.vue'
  import KendoTable from '../components/KendoTable'
  import Vue from 'vue'
  import axios from 'axios'
  import SiteFooter from '../components/SiteFooter.vue'
  import 'font-awesome/css/font-awesome.min.css'

  let db = Vue.prototype.$firebase.database()

  export default {
    components: {
      FeedbackComponent,
      KendoTable,
      SiteFooter
    },
    data () {
      return {
        favoritedItems: [],
        link: 'https://fed-exchange-api.herokuapp.com/api/v2.0/',
        dialog: false,
        recordsCount: 0,
        totalItems: 0,
        selectedRow: '',
        items: [],
        item: null,
        count: 0,
        search: '',
        companies: [],
        contracthistory: [],
        events: [],
        resources: [],
        groups: [],
        loading: false,
        tableHeader: [
          {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title'
          },
          {
            text: 'Action',
            align: 'left',
            sortable: false,
            value: 'link'
          }
        ],
        historyHeader: [
          {
            text: 'Vendor',
            align: 'left',
            sortable: false,
            value: 'title'
          },
          {
            text: 'Action',
            align: 'left',
            sortable: false,
            value: 'link'
          }
        ],
        directorySchema: [
          { title: 'Company', field: 'companylegalname', editable: false },
          { title: 'Address', field: 'streetaddress', editable: false },
          {
            title: 'SBA Certifications',
            field: 'companycertifications',
            editable: false
          }
        ],
        historySchema: [
          { title: 'Agency',
            field: 'majagencycat',
            editable: false
          },
          {
            title: 'Contract Action Type',
            field: 'contractactiontype',
            editable: false
          },
          {
            title: 'NAICS Description',
            field: 'naicsdescription',
            editable: false
          },
          {
            title: 'PCS Description',
            field: 'pscdescription',
            editable: false
          },
          {
            title: 'Solicitation Procedures',
            field: 'solicitationprocedures',
            editable: false
          }
        ],
        favorited: true,
        directoryUrl: '',
        historyUrl: '',
        contracts: [],
        historyDialog: false,
        seletedHistoryItem: null
      }
    },
    firebase () {
      return {
        favoriteDirectory: db.ref('favorites/directory'),
        favoriteHistory: db.ref('favorites/history'),
        favoriteEvents: db.ref('favorites/events')
      }
    },
    computed: {
      pages () {
        return this.$store.getters.getPages
      },
      styles () {
        return this.$store.getters.getStyles
      },
      state () {
        if (this.$store.getters.getCompanyDetails) { return this.$store.getters.getCompanyDetails.state }
      },
      breakpoint () {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {
      const payload = {
        meta: {
          'h1': 'Favorites',
          'title': 'Favorites',
          'description': 'Favorites Page',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)
      this.getCompanies()
      this.getContractHistory()
      this.getEvents()
    },
    methods: {
      getCompanies () {
        const self = this
        let userId = this.$store.getters.getUserDetails.uid
        this.$firebaseRefs.favoriteDirectory.child(`/${userId}`).once('value', function (result) {
          self.companies = []
          if (result.val()) {
            self.loading = true
            const companies = Object.keys(result.val())
            self.directoryUrl = self.link + `exchange-community-v2?_id=${companies.join('.')}`
            return axios
              .get(self.directoryUrl)
              .then(res => {
                const comp = res.data.data.map(val => {
                  return {
                    ...val,
                    firebaseRef: `favorites/directory/${userId}/${val._id}`,
                    link: `https://${window.location.host}/contractors#id=${val._id}`,
                    title: val.companylegalname
                  }
                })
                self.loading = false
                self.companies = comp
              })
          } else {
            self.loading = false
          }
        })
      },
      getContractHistory () {
        const self = this
        let userId = this.$store.getters.getUserDetails.uid
        this.$firebaseRefs.favoriteHistory.child(`/${userId}`).once('value', function (result) {
          self.contracthistory = []
          if (result.val()) {
            self.loading = true
            const historyIds = Object.keys(result.val() || {})
            self.directoryUrl = self.link + `ga-history-v2?id=${historyIds.join(',')}`
            return axios
              .get(self.directoryUrl)
              .then(res => {
                const comp = res.data.data.map(val => {
                  return {
                    ...val,
                    firebaseRef: `favorites/history/${userId}/${val.id}`,
                    link: `https://${window.location.host}/contract-history#id=${val.id}`,
                    title: val.recipient_name
                  }
                })
                self.loading = false
                self.contracthistory = comp
              })
          } else {
            self.loading = false
          }
        })
      },
      async getEvents () {
        const self = this
        this.loading = true
        let promises = []
        let userId = this.$store.getters.getUserDetails.uid
        const eventSnap = await this.$firebaseRefs.favoriteEvents.child(`/${userId}`).once('value')
        this.events = []
        const eventsId = Object.keys(eventSnap.val() || {})
        const eventsPromises = eventsId.map(event => {
          return self.$firebase.database().ref(`/events/${event}`).once('value')
        })
        promises = eventsPromises
        Promise
          .all(promises)
          .then(promise => {
            promise.forEach(eventSnap => {
              const event = eventSnap.val()
              event.firebaseRef = `favorites/events/${userId}/${eventSnap.key}`
              event.link = `https://${window.location.host}/events#id=${eventSnap.key}`
              self.events.push(event)
            })
            self.loading = false
          })
      },
      removeFavorite (ref) {
        this.$firebase.database().ref(ref).set(null).then(snap => {
          if (ref.indexOf('events') >= 0) {
            this.getEvents()
          } else if (ref.indexOf('directory') >= 0) {
            this.getCompanies()
          } else if (ref.indexOf('history') >= 0) {
            this.getContractHistory()
          }
        })
      },
      selectRow (e) {
        this.selectedRow = e
      },
      totalRecords (val) {
        this.recordsCount = val
      },
      moreInfo (val) {
        this.dialog = true
        this.item = val
      },
      moreInfoHistory (val) {
        this.historyDialog = true
        this.selectedHistoryItem = val
      },
      itemsLoaded (val) {
        // this.removeMarkers()
        this.items = val
        // this.loadMarkers()
      },
      cancel () {
        this.historyDialog = false
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// FavoritesView.vue?372303c0